<div class="w-full">
  <div class="flex flex-row items-center justify-between gap-4">
    <div class="flex items-center gap-2">
      @if (!hideSearch()) {
        <mat-form-field [subscriptSizing]="'dynamic'" class="w-44 md:w-64 lg:w-92">
          <button
            mat-button
            matTooltip="Rechercher (Alt+S)"
            [disabled]="disableActions()"
            mat-mdc-form-field-icon-prefix
            class="tertiary mr-2 flex h-6 w-6 items-center justify-center p-0"
          >
            @if (loading()) {
              <mat-icon class="spinning cursor-default text-base !text-[16px]">autorenew</mat-icon>
            } @else {
              <mat-icon (click)="triggerSearch(searchModel())" color="primary" class="!text-[16px]"
                >search</mat-icon
              >
            }
          </button>
          <input
            [formField]="searchFormTree"
            #searchInputRef
            matInput
            [placeholder]="searchPlaceHolder()"
            [attr.aria-label]="searchPlaceHolder() || 'Rechercher'"
            class="truncate placeholder:truncate placeholder:text-sm placeholder:text-gray"
          />
          @if (searchFormTree().errors().length) {
            <mat-error> Veuillez saisir 3 caractères au minimum </mat-error>
          }
        </mat-form-field>
      }
      @if (selectedCount() > 0) {
        @if (!hideSearch()) {
          <div class="bg-gray-4 h-6 w-px mx-2"></div>
        }
        <div class="text-primary text-sm font-medium">
          {{ selectedCount() | i18nPlural: selectionMapping }}
        </div>
        <button
          (click)="clearSelection.emit(null)"
          mat-button
          matTooltip="Annuler"
          class="tertiary flex items-center justify-center p-0"
        >
          <mat-icon class="text-xl">close</mat-icon>
        </button>

        <button mat-button matTooltip="Supprimer" class="tertiary flex items-center justify-center p-0">
          <mat-icon class="text-xl">delete</mat-icon>
        </button>
      }
    </div>
    <div class="flex items-center gap-1.5">
      @if (topButtons().length || topMenu()) {
        <section class="flex items-center gap-2">
          @for (button of topButtons(); track $index) {
            <button
              [disabled]="button.onDisabled ? button.onDisabled() : false"
              [ngClass]="getButtonClass(button)"
              [matTooltip]="button.label"
              (click)="button.onClick()"
              class="tertiary"
              mat-button
            >
              @if (button.icon) {
                <mat-icon color="primary">{{ button.icon }}</mat-icon>
              }
            </button>
          }
          @if (topMenu()) {
            <button
              [color]="$safeNavigationMigration(topMenu()?.color)"
              [matMenuTriggerFor]="menu"
              mat-button
              class="tertiary"
            >
              @if (topMenu()?.icon) {
                <mat-icon>{{ topMenu()?.icon }}</mat-icon>
              }

              {{ topMenu()?.label }}
            </button>
            <mat-menu #menu="matMenu">
              @for (action of topMenu()?.actions; track $index) {
                <button (click)="action.onClick()" mat-menu-item color="primary">
                  @if (action.icon) {
                    <mat-icon>{{ action.icon }}</mat-icon>
                  }

                  {{ action.label }}
                </button>
              }
            </mat-menu>
          }
          <div class="bg-gray-4 h-6 w-px mx-1"></div>
        </section>
      }

      <!-- Refresh -->
      @if (!hideRefresh()) {
        <button
          mat-button
          matTooltip="Actualiser (Alt+R)"
          class="tertiary"
          (click)="doTriggerRefresh()"
          [disabled]="disableActions()"
        >
          <mat-icon>refresh</mat-icon>
        </button>
      }

      <!-- Filtres -->
      @if (filters().length) {
        <aura-data-header-filters
          [filterTemplate]="filterTemplate()"
          [filters]="filters()"
          [mappedFilters]="mappedFilters()"
          [loading]="loading()"
          (triggerFiltering)="triggerFiltering.emit($event)"
          (clearFiltering)="clearFiltering.emit($event)"
          (removeFilter)="removeFilter.emit($event)"
          (filterView)="filterView.emit($event)"
        />
      }
      <!-- Paramètre des colonnes -->
      <button
        #columnTrigger="matMenuTrigger"
        [matMenuTriggerFor]="menuSettings"
        mat-button
        matTooltip="Personnalisation (Alt+C)"
        class="tertiary"
      >
        <mat-icon svgIcon="settings-2" />
      </button>
      <mat-menu #menuSettings="matMenu">
        <ng-template matMenuContent>
          <div class="w-[250px] px-4 py-3">
            <div class="flex flex-col">
              <div class="flex pb-2">
                <div class="content-center font-semibold">Colonnes</div>
              </div>
              <mat-divider></mat-divider>
              <aura-columns-customization [(columns)]="columns" (columnChanged)="doColumnChanged($event)" />
            </div>
          </div>
        </ng-template>
      </mat-menu>
    </div>
  </div>
  @if (mappedFilters().length || searchChip()) {
    <div class="pt-2">
      <aura-data-chips-filter-header
        [mappedFilters]="mappedFilters()"
        [searchChip]="searchChip()"
        (triggerSearch)="triggerSearch($event)"
        (triggerFiltering)="triggerFiltering.emit($event)"
        (removeFilter)="removeFilter.emit($event)"
      />
    </div>
  }
</div>
